/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { Component } from 'react';

import TableNoData from './TableNoData';

class TableErrorBoundary extends Component {

    state = { hasError: false };

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    render() {
        if (this.state.hasError) {
            return <TableNoData isError isDataLoaded={false}  />;
        }
        return this.props.children;
    }
}

export default TableErrorBoundary;
